<mat-card>
    <mat-card-header>    
       <mat-card-title class="popupHeader">
         <div class="mat-card-header-text" i18n>
           Unregister Device
         </div>       
       </mat-card-title>          
   </mat-card-header>
 
   <mat-card-content>
     <div class="container">
        <p i18n>NOTE: When a device is unregistered, the basic details of the device and the associated redlinings will be deleted permanently and cannot be retrieved later.</p>
        <p i18n>To successfully unregister the selected device, follow the steps below :</p>
        <p i18n>(1) Copy the generated device code by clicking the Copy button</p>
        <p i18n>(2) Paste the copied device code to your email and send to support@josoftware.de</p>
        <p i18n>(3) You will receive an email from our support team with the Unregister Code</p>
        <p i18n>(4) Copy and paste the Unregister Code in the field provided and click Unregister</p>
        <p i18n>(5) A message will be displayed conveying whether the unregistration was successful or not</p>
     </div>
   </mat-card-content>
 
   <mat-card-actions>
     <div class="buttonContent">
       <button mat-raised-button type="button" color="primary" (click)="onConfirm()" i18n>OK</button>
     </div>    
   </mat-card-actions>
 </mat-card>